function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const embeddedConfig = readEmbeddedConfig();
    const runtimeConfig = window.olfativaChatConfig || {};
    const endpoint = runtimeConfig.endpoint || embeddedConfig.endpoint || 'https://api.olfativahome.com/api/chat';
    const cartEndpoint = runtimeConfig.cartEndpoint || embeddedConfig.cartEndpoint || 'https://api.olfativahome.com/api/cart';
    const whatsAppUrl = runtimeConfig.whatsAppUrl || embeddedConfig.whatsAppUrl || '';
    let conversationState = 'inicio';
    let boundaryStrikes = 0;
    let scenarioProfile = null;
    let recommendationState = null;
    let lastNextQuestion = null;
    let isSending = false;
    let conversationUuid = generateUUID();
    const conversationTurns = [];

    function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    const moleculeStates = {
        waiting: 'waiting',
        responding: 'responding',
    };
    const suggestionDimensions = {
        lugar: null,
        objetivo: null,
        aroma: null,
    };

    const chatButtonMolecule = {
        color: '#C9A96E',
        nodes: [
            { x: 50, y: 12 },
            { x: 74, y: 28 },
            { x: 82, y: 55 },
            { x: 68, y: 78 },
            { x: 42, y: 82 },
            { x: 20, y: 68 },
            { x: 12, y: 42 },
            { x: 28, y: 18 },
            { x: 50, y: 45 },
        ],
        bonds: [
            [0, 1], [1, 2], [2, 3], [3, 4],
            [4, 5], [5, 6], [6, 7], [7, 0],
            [8, 0], [8, 2], [8, 4], [8, 6],
        ],
        colors: ['#C9A96E', '#E8A0B8', '#E89860', '#88C888', '#A8D870', '#E8C868', '#D4A0C0', '#C9A96E', '#E8A0B8'],
    };

    const chatButton = document.createElement('button');
    chatButton.id = 'olfativa-chat-button';
    chatButton.type = 'button';
    chatButton.setAttribute('aria-label', 'Abrir Asistente Olfativa');
    chatButton.innerHTML = `
        <span class="olfativa-chat-button-art">
            <canvas id="olfativa-chat-button-canvas" width="40" height="40" aria-hidden="true"></canvas>
        </span>
        <span class="olfativa-chat-button-text">Asistente Olfativa</span>
    `;

    const chatContainer = document.createElement('div');
    chatContainer.id = 'olfativa-chat-container';

    chatContainer.innerHTML = `
        <div id="olfativa-chat-header">
            <span>Asistente Olfativa</span>
            <button type="button" id="olfativa-chat-close" aria-label="Cerrar chat">
                &times;
            </button>
        </div>

        <div id="olfativa-chat-messages">
            <div class="olfativa-message bot">
                Hola, te ayudo a encontrar el aroma ideal para el ambiente que quieres crear.
            </div>
        </div>

        <div id="olfativa-chat-input-area">
            <input
                type="text"
                id="olfativa-chat-input"
                placeholder="Escribe un mensaje..."
            />

            <button id="olfativa-chat-send" type="button" aria-label="Enviar mensaje">
                <span class="olfativa-send-button-art">
                    <canvas id="olfativa-chat-send-canvas" width="18" height="18" aria-hidden="true"></canvas>
                </span>
                <span class="olfativa-send-button-text">Enviar</span>
            </button>
        </div>

        <div id="olfativa-chat-suggestions">
            <div class="olfativa-suggestion-card" data-dimension="aroma" role="button" tabindex="0">
                <div class="olfativa-suggestion-icon"></div>
                <span class="olfativa-suggestion-tag">Aroma</span>
                <h3>Tu estilo olfativo</h3>
                <p>Si te gustan notas cí­tricas, amaderadas, florales o quieres evitar algo, por ahí­ empezamos.</p>
            </div>
            <div class="olfativa-suggestion-card" data-dimension="lugar" role="button" tabindex="0">
                <div class="olfativa-suggestion-icon"></div>
                <span class="olfativa-suggestion-tag">Lugar o espacio</span>
                <h3>Tu espacio</h3>
                <p>Cuéntame cómo es el lugar: moderno, cálido, sobrio, elegante o minimalista.</p>
            </div>
            <div class="olfativa-suggestion-card" data-dimension="objetivo" role="button" tabindex="0">
                <div class="olfativa-suggestion-icon"></div>
                <span class="olfativa-suggestion-tag">Objetivo</span>
                <h3>Cómo lo quieres usar</h3>
                <p>Puede ser para uso diario, ocasiones especiales, eventos o para crear cierta atmósfera.</p>
            </div>
        </div>

    `;

    document.body.appendChild(chatButton);
    document.body.appendChild(chatContainer);

    rememberTurn('asistente', 'Hola, te ayudo a encontrar el aroma ideal para el ambiente que quieres crear.');

    function readEmbeddedConfig() {
        const configNode = document.getElementById('olfativa-chat-config');

        if (!configNode) {
            return {};
        }

        try {
            return JSON.parse(configNode.textContent || '{}');
        } catch (error) {
            return {};
        }
    }

    function createEmptyState(message) {
        const emptyState = document.createElement('div');
        emptyState.className = 'olfativa-chat-empty';
        emptyState.textContent = message;
        return emptyState;
    }

    function initMoleculeCanvas(canvas, stateResolver) {
        if (!canvas) {
            return;
        }

        const context = canvas.getContext('2d');

        if (!context) {
            return;
        }

        const width = canvas.width;
        const height = canvas.height;
        const scaleX = width / 100;
        const scaleY = height / 72;
        let frame = 0;

        function getNodes(time) {
            return chatButtonMolecule.nodes.map(function (node, index) {
                let x = node.x * scaleX;
                let y = node.y * scaleY;
                const centerX = width / 2;
                const centerY = height / 2;
                const dx = x - centerX;
                const dy = y - centerY;
                const state = stateResolver();

                if (state === moleculeStates.waiting) {
                    const spin = time * 1.4 + (index / chatButtonMolecule.nodes.length) * Math.PI * 2;
                    const radius = Math.sqrt(dx * dx + dy * dy);
                    const baseAngle = Math.atan2(dy, dx);
                    const nextAngle = baseAngle + spin * 0.4;
                    const pulse = 1 + Math.sin(time * 2.5 + index) * 0.14;

                    x = centerX + Math.cos(nextAngle) * radius * pulse;
                    y = centerY + Math.sin(nextAngle) * radius * pulse;
                } else {
                    const burst = Math.sin(time * 2.5 + index * 0.5);
                    const expand = 1 + Math.abs(burst) * 0.55;
                    const drift = Math.sin(time * 1.8 + index * 1.2) * Math.max(width * 0.12, 2);

                    x = centerX + dx * expand + drift;
                    y = centerY + dy * expand + Math.cos(time * 1.8 + index) * Math.max(height * 0.08, 2);
                }

                return { x: x, y: y };
            });
        }

        function drawFrame() {
            const time = frame * 0.016;
            const state = stateResolver();
            const glowRadius = state === moleculeStates.waiting ? width * 0.32 : width * 0.44;
            const nodes = getNodes(time);
            const glow = context.createRadialGradient(width / 2, height / 2, 0, width / 2, height / 2, glowRadius);

            context.clearRect(0, 0, width, height);
            glow.addColorStop(0, state === moleculeStates.waiting ? '#C9A96E4D' : '#C9A96E66');
            glow.addColorStop(1, 'transparent');
            context.fillStyle = glow;
            context.beginPath();
            context.arc(width / 2, height / 2, glowRadius * 1.2, 0, Math.PI * 2);
            context.fill();

            chatButtonMolecule.bonds.forEach(function (bond) {
                const start = nodes[bond[0]];
                const end = nodes[bond[1]];

                if (!start || !end) {
                    return;
                }

                context.globalAlpha = state === moleculeStates.waiting
                    ? 0.5 + Math.sin(time * 1.2 + bond[0] * 0.5) * 0.15
                    : 0.3 + Math.abs(Math.sin(time * 1.2 + bond[0] * 0.5)) * 0.2;
                context.strokeStyle = chatButtonMolecule.color;
                context.lineWidth = state === moleculeStates.waiting ? 0.9 : 0.7;
                context.beginPath();
                context.moveTo(start.x, start.y);
                context.lineTo(end.x, end.y);
                context.stroke();
            });

            nodes.forEach(function (node, index) {
                const color = chatButtonMolecule.colors[index % chatButtonMolecule.colors.length];
                const nodeSize = state === moleculeStates.waiting
                    ? 2.2 + Math.sin(time * 2.5 + index) * 0.8
                    : 2.2 + Math.abs(Math.sin(time * 2.5 + index)) * 1.5;
                const nodeGlow = context.createRadialGradient(node.x, node.y, 0, node.x, node.y, nodeSize * 2.5);

                context.globalAlpha = state === moleculeStates.waiting ? 0.2 : 0.35;
                nodeGlow.addColorStop(0, color);
                nodeGlow.addColorStop(1, 'transparent');
                context.fillStyle = nodeGlow;
                context.beginPath();
                context.arc(node.x, node.y, nodeSize * 2.5, 0, Math.PI * 2);
                context.fill();

                context.globalAlpha = state === moleculeStates.waiting
                    ? 0.7 + Math.sin(time * 2.5 + index * 0.7) * 0.25
                    : 0.8 + Math.abs(Math.sin(time * 2.5 + index)) * 0.2;
                context.fillStyle = color;
                context.beginPath();
                context.arc(node.x, node.y, nodeSize, 0, Math.PI * 2);
                context.fill();
            });

            context.globalAlpha = 1;
            frame += 1;
            window.requestAnimationFrame(drawFrame);
        }

        drawFrame();
    }

    function initChatButtonCanvas() {
        initMoleculeCanvas(
            document.getElementById('olfativa-chat-button-canvas'),
            function () {
                return moleculeStates.waiting;
            }
        );
    }

    function initSendButtonCanvas() {
        initMoleculeCanvas(
            document.getElementById('olfativa-chat-send-canvas'),
            function () {
                return moleculeStates.waiting;
            }
        );
    }

    function createLoadingIndicator() {
        const loading = document.createElement('span');
        const canvasId = `olfativa-loading-canvas-${Date.now()}-${Math.random().toString(16).slice(2, 8)}`;

        loading.className = 'olfativa-loading-text';
        loading.innerHTML = `
            <span class="olfativa-loading-art">
                <canvas id="${canvasId}" width="28" height="28" aria-hidden="true"></canvas>
            </span>
            <span class="olfativa-loading-label">Consultando</span>
        `;

        window.requestAnimationFrame(function () {
            initMoleculeCanvas(
                document.getElementById(canvasId),
                function () {
                    return moleculeStates.responding;
                }
            );
        });

        return loading;
    }

    initChatButtonCanvas();
    initSendButtonCanvas();
    attachSuggestionListeners();

    function formatProductPrice(product) {
        const amount = product?.price_amount;
        const currency = product?.price_currency;

        if (!amount || !currency) {
            return null;
        }

        const numericAmount = Number(amount);

        if (Number.isNaN(numericAmount)) {
            return null;
        }

        try {
            return new Intl.NumberFormat('es-MX', {
                style: 'currency',
                currency: currency,
                maximumFractionDigits: 2,
            }).format(numericAmount);
        } catch (error) {
            return `${amount} ${currency}`;
        }
    }

    function productDisplayTitle(product) {
        return product?.display_title || product?.catalog_name || product?.title || 'Producto';
    }

    function createProductCard(product) {
        const card = document.createElement('article');
        card.className = 'olfativa-product-card';
        const displayTitle = productDisplayTitle(product);

        if (product.image) {
            const imageLink = document.createElement('a');
            imageLink.className = 'olfativa-product-image-link';
            imageLink.href = product.url || '#';
            imageLink.target = '_blank';
            imageLink.rel = 'noopener noreferrer';

            const image = document.createElement('img');
            image.className = 'olfativa-product-image';
            image.src = product.image;
            image.alt = displayTitle;
            image.loading = 'lazy';

            imageLink.appendChild(image);
            card.appendChild(imageLink);
        }

        const content = document.createElement('div');
        content.className = 'olfativa-product-content';

        const title = document.createElement('h3');
        title.className = 'olfativa-product-title';
        title.textContent = displayTitle || 'Producto sin nombre';

        const description = document.createElement('p');
        description.className = 'olfativa-product-description';
        description.textContent = product.catalog_description
            || product.reason
            || product.description
            || 'Sin descripcion disponible.';

        const commerceRow = document.createElement('div');
        commerceRow.className = 'olfativa-product-commerce';

        const formattedPrice = formatProductPrice(product);

        if (formattedPrice) {
            const priceBlock = document.createElement('div');
            priceBlock.className = 'olfativa-product-price-block';

            const price = document.createElement('span');
            price.className = 'olfativa-product-price';
            price.textContent = `Ultimo precio revisado: ${formattedPrice}`;

            const priceNote = document.createElement('span');
            priceNote.className = 'olfativa-product-price-note';
            priceNote.textContent = 'Puede variar en el detalle actual.';

            priceBlock.appendChild(price);
            priceBlock.appendChild(priceNote);
            commerceRow.appendChild(priceBlock);
        }

        const actions = document.createElement('div');
        actions.className = 'olfativa-product-actions';

        const detailButton = document.createElement('a');
        detailButton.className = 'olfativa-product-button secondary';
        detailButton.href = product.url || '#';
        detailButton.target = '_blank';
        detailButton.rel = 'noopener noreferrer';
        detailButton.textContent = 'Ver producto';
        actions.appendChild(detailButton);

        if (product.product_id && product.variant_id) {
            const buyNowButton = document.createElement('button');
            buyNowButton.type = 'button';
            buyNowButton.className = 'olfativa-product-button';
            buyNowButton.textContent = 'Comprar ahora';
            buyNowButton.addEventListener('click', function () {
                startSingleProductCheckout(product, buyNowButton);
            });
            actions.appendChild(buyNowButton);
        }

        if (product.checkout_url) {
            const checkoutButton = document.createElement('a');
            checkoutButton.className = 'olfativa-product-button secondary';
            checkoutButton.href = product.checkout_url;
            checkoutButton.target = '_blank';
            checkoutButton.rel = 'noopener noreferrer';
            checkoutButton.textContent = 'Ir al checkout';
            actions.appendChild(checkoutButton);
        }

        content.appendChild(title);
        content.appendChild(description);
        commerceRow.appendChild(actions);
        content.appendChild(commerceRow);
        card.appendChild(content);

        return card;
    }

    function setButtonBusyState(button, active, busyLabel) {
        if (!button) {
            return;
        }

        if (!button.dataset.defaultLabel) {
            button.dataset.defaultLabel = button.textContent;
        }

        button.disabled = active;
        button.textContent = active
            ? (busyLabel || 'Abriendo checkout...')
            : button.dataset.defaultLabel;
    }

    function createCheckoutFallbackProduct(product) {
        return {
            title: product?.title || 'Producto',
            display_title: productDisplayTitle(product),
            url: product?.url || '#',
            image: product?.image || null,
            catalog_description: product?.catalog_description || null,
            reason: product?.reason || product?.description || 'Te dejo el enlace de detalle para que lo revises con calma.',
            price_amount: product?.price_amount || null,
            price_currency: product?.price_currency || null,
            product_id: null,
            variant_id: null,
            checkout_url: null,
        };
    }

    function appendCheckoutFallbackMessage(product) {
        const messages = document.getElementById('olfativa-chat-messages');
        const botMessage = document.createElement('div');
        botMessage.className = 'olfativa-message bot';

        const heading = document.createElement('div');
        heading.className = 'olfativa-chat-response-title';
        heading.textContent = 'No pude abrir el checkout en este momento, pero te dejo aquíƒÂ­ el detalle del producto. Si quieres, un asesor te atiende directo por WhatsApp y te ayuda con la compra.';
        botMessage.appendChild(heading);

        botMessage.appendChild(renderProducts([createCheckoutFallbackProduct(product)]));

        if (whatsAppUrl) {
            const actionLink = createActionLink({
                label: 'Te atendemos por WhatsApp',
                url: whatsAppUrl,
                type: 'whatsapp',
            });

            if (actionLink) {
                botMessage.appendChild(actionLink);
            }
        }

        messages.appendChild(botMessage);
        botMessage.scrollIntoView({
            block: 'start',
            behavior: 'smooth',
        });
    }

    async function createCheckoutForProduct(product) {
        const response = await fetch(cartEndpoint, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: [
                    {
                        product_id: product.product_id,
                        variant_id: product.variant_id,
                        selling_plan_id: product.selling_plan_id || null,
                        quantity: 1,
                    },
                ],
            }),
        });

        let payload = null;

        try {
            payload = await response.json();
        } catch (error) {
            payload = null;
        }

        if (!response.ok) {
            const message = payload?.message || 'No pudimos abrir el checkout en este momento.';
            throw new Error(message);
        }

        if (!payload?.checkout_url) {
            throw new Error('No recibimos un enlace de checkout valido.');
        }

        return payload;
    }

    async function startSingleProductCheckout(product, triggerButton) {
        if (!product?.product_id || !product?.variant_id) {
            return;
        }

        setButtonBusyState(triggerButton, true, 'Abriendo checkout...');

        try {
            const checkout = await createCheckoutForProduct(product);
            window.location.href = checkout.checkout_url;
        } catch (error) {
            appendCheckoutFallbackMessage(product);
        } finally {
            setButtonBusyState(triggerButton, false);
        }
    }

    function createActionLink(action) {
        if (!action || !action.url) {
            return null;
        }

        const link = document.createElement('a');
        link.className = 'olfativa-product-button';

        if (action.type === 'whatsapp') {
            link.classList.add('whatsapp');
        }

        link.href = action.url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = action.label || 'Hablar por WhatsApp';

        return link;
    }

    function getSuggestedProducts(payload) {
        if (Array.isArray(payload)) {
            return payload;
        }

        if (Array.isArray(payload?.suggested_products)) {
            return payload.suggested_products;
        }

        if (Array.isArray(payload?.items)) {
            return payload.items;
        }

        return [];
    }

    function setSendingState(active) {
        const input = document.getElementById('olfativa-chat-input');
        const sendButton = document.getElementById('olfativa-chat-send');
        const sendButtonText = sendButton.querySelector('.olfativa-send-button-text');

        isSending = active;
        input.disabled = active;
        sendButton.disabled = active;

        if (sendButtonText) {
            sendButtonText.textContent = active ? 'Consultando' : 'Enviar';
        }
    }

    function renderProducts(products) {
        const fragment = document.createDocumentFragment();
        const list = document.createElement('div');
        list.className = 'olfativa-product-list';

        products.forEach(function (product) {
            list.appendChild(createProductCard(product));
        });

        fragment.appendChild(list);
        return fragment;
    }

    function rememberTurn(role, content) {
        const normalizedContent = String(content || '').trim();

        if (!normalizedContent) {
            return;
        }

        conversationTurns.push({
            role: role,
            content: normalizedContent,
        });
    }

    function buildConversationSummary() {
        return conversationTurns
            .slice(-10)//last ten pushes
            .map(function (turn) {
                return `${turn.role}: ${turn.content}`;
            })
            .join(' | ')
            .slice(-3500);
    }

    function buildSuggestionPhrase() {
        const parts = [];

        if (suggestionDimensions.lugar) {
            parts.push(`quiero un aroma para mi ${suggestionDimensions.lugar}`);
        }
        if (suggestionDimensions.objetivo) {
            parts.push(`el objetivo es que sea ${suggestionDimensions.objetivo}`);
        }
        if (suggestionDimensions.aroma) {
            parts.push(`los aromas que me gustan son ${suggestionDimensions.aroma}`);
        }

        if (parts.length === 0) {
            return null;
        }

        return 'Hola, ' + parts.join(', ');
    }

    function showSuggestionOptions(dimension) {
        const suggestions = document.getElementById('olfativa-chat-suggestions');

        if (window.olfativaRenderOptions) {
            window.olfativaRenderOptions(suggestions, dimension,
                function (selected) {
                    suggestionDimensions[dimension] = selected;
                    const phrase = buildSuggestionPhrase();
                    if (phrase && Object.values(suggestionDimensions).filter(Boolean).length >= 2) {
                        sendSuggestionMessage(phrase);
                    } else {
                        setTimeout(function () {
                            suggestions.innerHTML = '';
                            initSuggestionCards();
                        }, 500);
                    }
                },
                function () {
                    suggestions.innerHTML = '';
                    initSuggestionCards();
                }
            );
        }
    }

    function sendSuggestionMessage(phrase) {
        const input = document.getElementById('olfativa-chat-input');
        input.value = phrase;
        sendMessage();
        setTimeout(function () {
            suggestionDimensions.lugar = null;
            suggestionDimensions.objetivo = null;
            suggestionDimensions.aroma = null;
            initSuggestionCards();
        }, 500);
    }

    function initSuggestionCards() {
        const suggestions = document.getElementById('olfativa-chat-suggestions');
        suggestions.innerHTML = `
            <div class="olfativa-suggestion-card" data-dimension="aroma" role="button" tabindex="0">
                <div class="olfativa-suggestion-icon"></div>
                <span class="olfativa-suggestion-tag">Aroma</span>
                <h3>Tu estilo olfativo</h3>
                <p>Si te gustan notas cí­tricas, amaderadas, florales o quieres evitar algo, por ahí­ empezamos.</p>
            </div>
            <div class="olfativa-suggestion-card" data-dimension="lugar" role="button" tabindex="0">
                <div class="olfativa-suggestion-icon"></div>
                <span class="olfativa-suggestion-tag">Lugar o espacio</span>
                <h3>Tu espacio</h3>
                <p>Cuéntame cómo es el lugar: moderno, cálido, sobrio, elegante o minimalista.</p>
            </div>
            <div class="olfativa-suggestion-card" data-dimension="objetivo" role="button" tabindex="0">
                <div class="olfativa-suggestion-icon"></div>
                <span class="olfativa-suggestion-tag">Objetivo</span>
                <h3>Cómo lo quieres usar</h3>
                <p>Puede ser para uso diario, ocasiones especiales, eventos o para crear cierta atmósfera.</p>
            </div>
        `;
        attachSuggestionListeners();
    }

    function attachSuggestionListeners() {
        const cards = document.querySelectorAll('.olfativa-suggestion-card[data-dimension]');
        cards.forEach(function (card) {
            card.style.cursor = 'pointer';
            card.onclick = function (e) {
                e.stopPropagation();
                const dimension = card.getAttribute('data-dimension');
                showSuggestionOptions(dimension);
            };
        });
    }

    async function sendMessage() {
        if (isSending) {
            return;
        }

        const input = document.getElementById('olfativa-chat-input');
        const text = input.value.trim();

        if (!text) {
            return;
        }

        input.value = '';
        setSendingState(true);

        const messages = document.getElementById('olfativa-chat-messages');

        const userMessage = document.createElement('div');
        userMessage.className = 'olfativa-message user';
        userMessage.innerText = text;
        messages.appendChild(userMessage);
        rememberTurn('usuario', text);

        const botMessage = document.createElement('div');
        botMessage.className = 'olfativa-message bot';
        botMessage.appendChild(createLoadingIndicator());
        messages.appendChild(botMessage);
        botMessage.scrollIntoView({
            block: 'end',
            behavior: 'smooth',
        });

        try {
            const res = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    message: text,
                    conversation_uuid: conversationUuid,
                    conversation_summary: buildConversationSummary(),
                    boundary_strikes: boundaryStrikes,
                    scenario_profile: scenarioProfile,
                    recommendation_state: recommendationState,
                    conversation_state: conversationState,
                    last_next_question: lastNextQuestion,
                }),
            });

            const data = await res.json();
            const assistantMessage = data.assistant_message || 'Respuesta del asistente';
            const nextQuestion = data.next_question || null;
            const suggestedProducts = getSuggestedProducts(data);

            botMessage.textContent = '';

            const heading = document.createElement('div');
            heading.className = 'olfativa-chat-response-title';
            heading.textContent = assistantMessage;
            botMessage.appendChild(heading);

            if (suggestedProducts.length) {
                botMessage.appendChild(renderProducts(suggestedProducts));
            }

            if (data.call_to_action) {
                const actionLink = createActionLink(data.call_to_action);

                if (actionLink) {
                    botMessage.appendChild(actionLink);
                }
            }

            conversationState = data.conversation_state || conversationState;
            scenarioProfile = data.scenario_profile || scenarioProfile;
            if (Object.prototype.hasOwnProperty.call(data, 'recommendation_state')) {
                recommendationState = data.recommendation_state;
            }
            lastNextQuestion = nextQuestion;
            boundaryStrikes = conversationState === 'fuera_de_alcance'
                ? Math.min(boundaryStrikes + 1, 50)
                : 0;
            rememberTurn('asistente', assistantMessage);

            const shownProductTitles = suggestedProducts
                .map(function (product) {
                    return productDisplayTitle(product);
                })
                .filter(Boolean)
                .join(', ');

            if (shownProductTitles) {
                rememberTurn('catalogo', shownProductTitles);
            }

            botMessage.scrollIntoView({
                block: 'start',
                behavior: 'smooth',
            });
        } catch (error) {
            console.error(error);
            botMessage.textContent = '';
            botMessage.appendChild(createEmptyState('Error consultando la API.'));
        } finally {
            setSendingState(false);
            input.focus();
        }
    }

    chatButton.addEventListener('click', function () {
        const isVisible = chatContainer.style.display === 'flex';
        chatContainer.style.display = isVisible ? 'none' : 'flex';
    });

    document
        .getElementById('olfativa-chat-close')
        .addEventListener('click', function () {
            chatContainer.style.display = 'none';
        });

    document
        .getElementById('olfativa-chat-send')
        .addEventListener('click', sendMessage);

    document
        .getElementById('olfativa-chat-input')
        .addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                sendMessage();
            }
        });
});